// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { FOUNDERS_AND_PARTNERS_REDUCER_KEY } from "..";
import { getPeriodValue } from "./helpers";
import {
  hp_fp_advisoryBoardMonth,
  hp_fp_costPerHeadMonth,
  hp_fp_foundersAndPartnersHeaderMonth,
  hp_fp_foundersMonth,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

const prefix = "hp_fp_";

// other revenue keys
export const FOUNDERS_AND_PARTNERS_HEADER_KEY =
  prefix + "foundersAndPartnersHeader";
export const HEAD_COUNT_KEY = prefix + "headCount";
export const FOUNDERS_KEY = prefix + "founders";
export const ADVISORY_BOARD_KEY = prefix + "advisoryBoard";
export const COST_PER_HEAD_KEY = prefix + "costPerHead";

export const hpFoundersAndPartnersItems = [
  FOUNDERS_AND_PARTNERS_HEADER_KEY,
  HEAD_COUNT_KEY,
  FOUNDERS_KEY,
  ADVISORY_BOARD_KEY,
  COST_PER_HEAD_KEY,
];

export const initialState = {
  [FOUNDERS_AND_PARTNERS_HEADER_KEY]: {
    title: "Founders and Partners",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const headCount = Number(
        getReducerFunc(FOUNDERS_AND_PARTNERS_REDUCER_KEY)[
          HEAD_COUNT_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
      const costPerHead = getPeriodValue(
        getReducerFunc(FOUNDERS_AND_PARTNERS_REDUCER_KEY)[COST_PER_HEAD_KEY],
        yearKey,
        getReducerFunc
      );

      return headCount * costPerHead;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [HEAD_COUNT_KEY]: {
    title: "Head Count",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return (
        getPeriodValue(
          getReducerFunc(FOUNDERS_AND_PARTNERS_REDUCER_KEY)[FOUNDERS_KEY],
          yearKey,
          getReducerFunc
        ) +
        getPeriodValue(
          getReducerFunc(FOUNDERS_AND_PARTNERS_REDUCER_KEY)[ADVISORY_BOARD_KEY],
          yearKey,
          getReducerFunc
        )
      );
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [FOUNDERS_KEY]: {
    title: "Founders",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_fp_foundersMonth,
    years: {
      [years.YEAR_1_KEY]: 3,
      [years.YEAR_2_KEY]: 3,
      [years.YEAR_3_KEY]: 3,
      [years.YEAR_4_KEY]: 3,
      [years.YEAR_5_KEY]: 3,
    },
  },
  [ADVISORY_BOARD_KEY]: {
    title: "Advisory Board",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_fp_advisoryBoardMonth,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 2,
      [years.YEAR_4_KEY]: 2,
      [years.YEAR_5_KEY]: 3,
    },
  },
  [COST_PER_HEAD_KEY]: {
    title: "Cost per Head",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_fp_costPerHeadMonth,
    years: {
      [years.YEAR_1_KEY]: 4000,
      [years.YEAR_2_KEY]: 4000,
      [years.YEAR_3_KEY]: 4000,
      [years.YEAR_4_KEY]: 4000,
      [years.YEAR_5_KEY]: 4000,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const hpFoundersAndPartnersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FOUNDERS_AND_PARTNERS_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_FOUNDERS_AND_PARTNERS_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_FOUNDERS_AND_PARTNERS_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_FOUNDERS_AND_PARTNERS_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default hpFoundersAndPartnersReducer;
